<template>
  <div>
    <LinkInBio v-if="transientLinkInBio.id != ''" />

    <div v-else></div>
  </div>
</template>

<script>
import LinkInBio from "@/views/LinkInBio";
import { mapGetters } from "vuex";

export default {
  components: {
    LinkInBio,
  },
  computed: {
    ...mapGetters(["transientLinkInBio"]),
  },
};
</script>

<style></style>
